/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _MedicalEventEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from "@ember/service";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import MedicalEventJournalEvent from "core/models/medical-event-journal-event";
import SemeiaSessionService from "core/services/session";
import { ValidatorMap } from "ember-changeset/types";
import IntlService from "ember-intl/services/intl";
let MedicalEventEditionFormComponent = (_class = (_MedicalEventEditionFormComponent = class MedicalEventEditionFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "submitButtonTitle", "Sauvegarder");
    _defineProperty(this, "afterCompleted", () => {
      if (!this.session.medic) this.router.transitionTo("/patient-web/chat");else {
        const tab = this.changeset.get("willSendMessage") ? "consult-chat" : "consult-timeline";
        this.router.transitionTo(`/medics-web/patients/${this.patient.id}/dashboard`, {
          queryParams: {
            tab
          }
        });
      }
    });
  }
  get validations() {
    return this.journalEventClass.validations(this.intl);
  }
  get occurredAt() {
    return this.changeset.get("occurredAt") ? this.intl.formatDate(this.changeset.get("occurredAt")) : "date inconnue";
  }
  get interventionType() {
    return this.changeset.get("interventionType") || "type inconnu";
  }
  get comment() {
    return this.changeset.get("comment") || "";
  }
  get allInterventionTypes() {
    const interventionTypes = ["Hospitalisation", "Intervention chirurgicale", "Consultation spécialiste", "Examen médical", "Suivi médicamenteux", "État de santé", "Une infection", "Un retard de règle, une grossesse", "Un problème avec mon traitement", "Un nouveau médicament", "Un problème de peau", "Autre"];
    return interventionTypes;
  }
  async save() {
    const model = await super.save();
    if (!this.changeset.get("willSendMessage") && !this.session.patient) return model;
    await this.store.createRecord("patient-chat-message-sent-journal-event", {
      occurredAt: new Date(),
      triggeringJournalEvent: model,
      patient: model.patient,
      creator: model.creator,
      body: "Événement médical envoyé"
    }).save();
    return model;
  }
}, _defineProperty(_MedicalEventEditionFormComponent, "forcDisplayName", "Événement médical"), _defineProperty(_MedicalEventEditionFormComponent, "fullComponentId", "medical-event/edition-form"), _defineProperty(_MedicalEventEditionFormComponent, "journalEventClass", MedicalEventJournalEvent), _MedicalEventEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MedicalEventEditionFormComponent as default };